import { render } from "./logout.html?vue&type=template&id=4f140954&scoped=true&ts=true&external"
import script from "./logout.ts?vue&type=script&lang=ts&external"
export * from "./logout.ts?vue&type=script&lang=ts&external"

import "./logout.scss?vue&type=style&index=0&id=4f140954&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f140954"]])

export default __exports__